import { useQuery } from "@tanstack/react-query"
import { queryKeys } from "~/constants/queryKeys"
import api from "~/api2"
import { SchemaResponse } from "~/api2/dynamic_forms"
import { useLocation, useNavigate } from "react-router-dom"
import { ROUTER_PATHS } from "~/routes/constants"

export const useDynamicFormsSchema = () => {
  const navigate = useNavigate()
  const location = useLocation()
  
  const fetchSchemaQuery = useQuery<SchemaResponse>({
    enabled: location.pathname.includes(ROUTER_PATHS.ADMIN_SETTINGS),
    queryKey: [queryKeys.DYNAMIC_FORMS_SCHEMA],
    queryFn: async () => {
      try {
        const response = await api.DynamicForms.schema()
        return response
      } catch (error: any) {
        if ((error?.status === 403 || error?.status === 401)) {
          const currentPath = location.pathname
          const isRouterPathValue = Object.values(ROUTER_PATHS).includes(currentPath)
          if (!isRouterPathValue) {
            navigate(ROUTER_PATHS.UNAUTHORIZED)
          }

          return { models: [] }
        }
        throw error
      }
    },
  })

  return {
    index: fetchSchemaQuery,
  }
}
